import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';
import { useConfig } from '../context/ConfigContext';

const Streaming = () => {
    const [stream, setStream] = useState({ url: '', description: '' });
    const [isLoading, setIsLoading] = useState(true);
    const { config } = useConfig();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const streamRes = await api.get('/streaming');
            setStream(streamRes.data);
        } catch (error) {
            console.error("Error fetching", error);
        } finally {
            setIsLoading(false);
        }
    };

    const pageDesign = config?.pageDesigns?.streaming || {};
    const showTitle = pageDesign.showTitle !== false;
    const pageTitle = pageDesign.title || 'En Vivo';
    const pageSubtitle = pageDesign.subtitle || 'Señal en tiempo real';

    return (
        <div className="animate-fadeIn max-w-4xl mx-auto pb-32">
            {isLoading ? (
                <div className="flex flex-col items-center justify-center py-20">
                    <div className="w-12 h-12 border-4 border-white/5 border-t-purple-500 rounded-full animate-spin"></div>
                    <p className="text-white/20 text-[10px] font-black uppercase tracking-[0.4em] mt-6 animate-pulse">Sintonizando Señal...</p>
                </div>
            ) : (
                <div className="space-y-12">
                    {/* Video Player Section */}
                    <section className="bg-black/40 backdrop-blur-2xl rounded-[40px] overflow-hidden border border-white/10 shadow-2xl relative group">
                        <div className="aspect-video w-full bg-black relative">
                            {stream.url ? (
                                <iframe 
                                    src={stream.url} 
                                    className="w-full h-full" 
                                    frameBorder="0" 
                                    allow="autoplay; fullscreen" 
                                    allowFullScreen
                                    title="Live Event"
                                ></iframe>
                            ) : (
                                <div className="flex flex-col items-center justify-center h-full text-white/10 px-6 text-center">
                                    <span className="text-7xl mb-6 grayscale opacity-20 animate-pulse">📺</span>
                                    <p className="text-xs font-black uppercase tracking-[0.3em]">La transmisión comenzará pronto</p>
                                </div>
                            )}
                        </div>
                        <div className="p-10 bg-gradient-to-br from-white/5 to-transparent flex justify-between items-center">
                            <div className="max-w-xl">
                                {showTitle && (
                                    <h1 className="text-3xl font-black mb-2 tracking-tight text-white uppercase italic">{pageTitle}</h1>
                                )}
                                <p className="text-white/40 text-[11px] font-black uppercase tracking-widest">{stream.description || pageSubtitle}</p>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-red-500 animate-ping"></div>
                                <span className="text-[10px] font-black uppercase tracking-widest text-red-500">Live</span>
                            </div>
                        </div>
                    </section>
                </div>
            )}
        </div>
    );
};

export default Streaming;
